import BreadcrumbsBlock from "./BreadcrumbsBlock";

export * from "./BreadcrumbsBlock";
export default BreadcrumbsBlock;
